/**
 * @generated SignedSource<<34a709fabc40ada1ebe23ab5e7619ae1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck$data = {
  readonly checkValue: TaskSentiment | null;
  readonly " $fragmentType": "WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck";
};
export type WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck$key = {
  readonly " $data"?: WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkValue",
      "storageKey": null
    }
  ],
  "type": "TaskExecutionCheck",
  "abstractKey": null
};

(node as any).hash = "783f121181729319b1164878afe538b6";

export default node;
